// Import Mantine
import { MantineProvider } from "@mantine/core";
import { Notifications } from "@mantine/notifications";
import { ModalsProvider } from "@mantine/modals";
import { theme, resolver } from "@/lib/mantine-styles/theme";
import { ProgressProvider } from "@bprogress/next/pages";

// Import Session and Layout
import { SessionProvider } from "next-auth/react";
import Layout from "../components/_App/Layout";

// Import utilities and modal setup
import React from "react";
import mdEditorConfig from "@/utils/mdEditorConfig";

// Import custom pages for errors
import Error from "pages/_error";
import Custom404 from "pages/404";
import Custom500 from "pages/500";

// Import global styles
import "react-tabs/style/react-tabs.css";
import "stream-chat-react/dist/css/v2/index.css";
import "@flaticon/flaticon-uicons/css/regular/rounded.css";
import "@flaticon/flaticon-uicons/css/brands/all.css";
import "@mantine/core/styles.css";
import "@mantine/dates/styles.css";
import "@mantine/notifications/styles.css";
import "@mantine/spotlight/styles.css";
import "mantine-react-table/styles.css";
import "md-editor-rt/lib/preview.css";
import "md-editor-rt/lib/style.css";
import "../styles/main.css";
import "../styles/responsive.css";

mdEditorConfig();

const MyApp = ({ Component, pageProps }) => {
  const { session, error, key, ...otherPageProps } = pageProps;

  const getLayout = (page) => (
    <Layout key={key} {...otherPageProps}>
      {page}
    </Layout>
  );

  const renderPage = () => {
    if (error) {
      switch (error.code) {
        case 404:
          return getLayout(<Custom404 />);
        case 500:
          return getLayout(<Custom500 />);
        default:
          return getLayout(<Error />);
      }
    }
    return getLayout(<Component {...otherPageProps} />);
  };

  return (
    <SessionProvider session={session}>
      <ProgressProvider height="3px" spinnerPosition="bottom-left" color="#a842fc" options={{ showSpinner: false }}>
        <MantineProvider withGlobalStyles withNormalizeCSS theme={theme} cssVariablesResolver={resolver}>
          <ModalsProvider>
            <Notifications position="top-center" />
            {renderPage()}
          </ModalsProvider>
        </MantineProvider>
      </ProgressProvider>
    </SessionProvider>
  );
};

export default MyApp;
